import React, { Fragment } from 'react';

import useMultiselectView from './UseMultiselectView';

import CategoryMeasureMultiselect from '../../multiselect/categoryMeasureMultiselect/CategoryMeasureMultiselect';

import Headings from '@usas/ui-web/components/headings/Headings';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';
import ReadOnly from '@usas/ui-web/components/readOnly/ReadOnly';

import Constants from '@usas/ui-web/utils/Constants';

const Label = ({ question }) => (
  <div dangerouslySetInnerHTML={{ __html: question }} />
);

const MultiselectView = ({ programLevel, categoryMeasure, isReadonly = false, onRedirect }) => {
  const {
    categoryMeasureScoreState,
    categoryMeasureMultiselectState,
    formState,
    errorState,
    handleSubmit,
    onFormValueChanged,
    onSaveClicked,
    getMultiValueString
  } = useMultiselectView(programLevel, categoryMeasure, isReadonly, onRedirect);

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H3>{categoryMeasure.measureName}</Headings.H3>
        </div>
      </div>
      <form onSubmit={handleSubmit} noValidate>
        <div className="row">
          <div className="col-xs-12 col-sm-8">
            {isReadonly === true
              ? (
                <ReadOnly
                  label={<Label question={categoryMeasure?.question} />}
                  name="multiSelectValues"
                  value={getMultiValueString(formState.multiSelectValues)} />
              ) : (
                <CategoryMeasureMultiselect
                  label={<Label question={categoryMeasure.question} />}
                  name="multiSelectValues"
                  value={formState.multiSelectValues}
                  error={errorState.multiSelectValues}
                  message={errorState.multiSelectValues}
                  onChange={(value) => { onFormValueChanged('multiSelectValues', value); }}
                  categoryMeasureId={categoryMeasure.categoryMeasureId} />
              )}
          </div>
        </div>
        <div className="row usas-extra-top-margin usas-extra-bottom-margin">
          {isReadonly === true
            ? (
              <div className="col-xs-12 usas-extra-top-margin">
                <SecondaryButton type="button" onClick={() => onRedirect(false)}>Back</SecondaryButton>
              </div>
            ) : (
              <div className="col-xs-12 usas-extra-top-margin">
                <PrimaryButton type="button" onClick={onSaveClicked}>Save</PrimaryButton>&nbsp;
                <SecondaryButton type="button" onClick={() => onRedirect(false)}>Back</SecondaryButton>
              </div>
            )
          }
        </div>
      </form>
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={categoryMeasureMultiselectState.isArrayLoading} />
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.SAVING_MSG}
        displayPopUp={categoryMeasureScoreState.isSaving} />
    </Fragment>
  );
};

export default MultiselectView;